module.exports = __webpack_public_path__ + "static/media/tournament.07ad4de4.jpg";